export class Osc {
    private _val: number;
    private _rate: number;
    private _dir: boolean;
    private _flip: boolean;
    private _valBase: number;
    private _rateBase: number;
    private _dirBase: boolean;
    private _flipBase: boolean;
    public trigger: boolean;
    public triggerTop: boolean;
    public triggerBot: boolean;
  
    constructor(val: number, rate: number, dir = true, flip = false) {
      this._val = val;
      this._rate = rate;
      this._dir = dir;
      this._flip = flip;
  
      this._valBase = val;
      this._rateBase = rate;
      this._dirBase = dir;
      this._flipBase = flip;
  
      this.trigger = false;
      this.triggerTop = false;
      this.triggerBot = false;
    }
  
    reset(): void {
      this._val = this._valBase;
      this._rate = this._rateBase;
      this._dir = this._dirBase;
      this._flip = this._flipBase;
      this.trigger = this.triggerTop = this.triggerBot = false;
    }
  
    update(dt: number): void {
      this.trigger = this.triggerTop = this.triggerBot = false;
      if (this._dir) {
        if (this._val < 1) {
          this._val += this._rate * dt;
        } else {
          this.trigger = this.triggerTop = true;
          if (this._flip) this._val -= 1;
          else {
            this._val = 1 - (this._val - 1);
            this._dir = !this._dir;
          }
        }
      } else {
        if (this._val > 0) {
          this._val -= this._rate * dt;
        } else {
          this.trigger = this.triggerBot = true;
          if (this._flip) this._val = 1 + this._val;
          else {
            this._val = -this._val;
            this._dir = !this._dir;
          }
        }
      }
    }
  
    val(ease?: (t: number, b: number, c: number, d: number) => number) {
      return ease ? ease(this._val, 0, 1, 1) : this._val;
    }
  }
  